import axios from '../requester';
import { API } from '../constants/api-urls';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import {
  SESSION_STORAGE_KEYS,
  IDENTITY_PROVIDERS
} from 'common/constants/constants';
import { omitFromQs, redirectToProvider } from 'common/utils/utils';
import QueryString from 'query-string';
import { createExistingSlackWorkSpaceModalOptions } from 'modals/modal-options-factory';

export const getOrgSlackChannels = async () =>
  axios.get(`${API.SLACK_PATH}/channels`).catch(() => []);

export const redirectToSlack = (
  team,
  slackSensorAuhorizationId,
  reAuth = false,
  redirectPath = 'settings/slack',
  isOrgSettings = true
) => {
  if (team && team.id) {
    BrowserStorageAccessor().session.set(
      SESSION_STORAGE_KEYS.SLACK_REDIRECT_TEAM_ID,
      team.id
    );
  }
  const queryParams = {
    reauth: reAuth,
    isOrgSettings,
    ...(window.location.search.includes('isE2eTestFlow')
      ? { isE2eTestFlow: 1 }
      : {}),
    ...(reAuth ? { sensor_auth_id: slackSensorAuhorizationId } : {})
  };

  redirectToProvider(IDENTITY_PROVIDERS.SLACK, {
    redirectPath,
    query: queryParams
  });
};

export const handlePostSlackAuth = ({ toggleModal }) => {
  const search = QueryString.parse(window.location.search, {
    ignoreQueryPrefix: true
  });
  const { existingSlackWs } = search;

  if (existingSlackWs) {
    omitFromQs('existingSlackWs');
    toggleModal(createExistingSlackWorkSpaceModalOptions({}));
  }
};

export const SLACK_STATUSES = {
  NOT_CONNETED: 'not-connected',
  CONNECTED: 'connected',
  RE_AUTH_NEEDED: 'reAuth'
};
